<svelte:options customElement="dst-push-notifications" />

<script lang="ts">
	import { register as registerClosables } from '@/lib/closable.ts';
	import { Logger } from '@/lib/log.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import { afterUpdate, beforeUpdate } from 'svelte';

	const log = Logger('header.DstPushNotifications');

	beforeUpdate(() => {
		if (import.meta.env.VITE_CLEVERPUSH_CONFIG_OVERRIDE === 'true') {
			window.cleverPushConfig = {
				gcmManifestPath: import.meta.env.VITE_CLEVERPUSH_MANIFEST_URL,
				serviceWorkerFile: import.meta.env.VITE_CLEVERPUSH_SERVICE_WORKER_URL,
			};

			log.debug(
				`overriding default cleverpush config. using serviceWorkerFile: ${window.cleverPushConfig.serviceWorkerFile}`,
			);
		}
	});

	afterUpdate(() => {
		const root: HTMLElement = document.querySelector('[data-closable="dialog-cleverpush-settings"]');

		registerClosables(root, $closableInformElement);
	});
</script>

<svelte:head>
	<script id="cleverpush-script" src={import.meta.env.VITE_CLEVERPUSH_URL} async></script>
	<script>
		const cleverpushSettings = `
      <div class="cleverpush-settings" data-closable="dialog-cleverpush-settings" data-closable-active="false">
        <section role="dialog" class="cleverpush-confirm-wrap" aria-modal="true" aria-labelledby="cleverpush-content-button-title">
          <div class="cleverpush-content-button"
            data-type="box-simple"
            data-text="Sofort informiert: Bleiben Sie mit unseren kostenlosen Pushnachrichten am Laufenden und wählen Sie die Themen selbst. Stornierung jederzeit möglich. Weitere Informationen zur Verarbeitung Ihrer Daten können Sie unserer Datenschutzerklärung entnehmen."
            data-button-text="Push Nachrichten erhalten"
            data-button-text-subscribed="Push Nachrichten abonniert">
          </div>
          <button type="button" aria-label="Schließen" class="cleverpush-settings--close" data-closable-target="dialog-cleverpush-settings">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
          </button>
        </section>
      </div>`;

		document.body.insertAdjacentHTML('beforeend', cleverpushSettings);
	</script>

	<style lang="scss">
		@use './DstPushNotifications.scss';
	</style>
</svelte:head>
